<script setup lang="ts">
  import MainLayout from 'views/layouts/MainLayout.vue'
  import FormUser from 'components/Assine/FormUser.vue'
  import FormPlansCreditsSelect from 'components/Assine/FormPlansCreditsSelect.vue'
  import FormCheckout from 'components/Credits/FormCheckout.vue'
  import TermsUse from 'components/Assine/TermsUse.vue'
  import ModalMessages from 'components/Modais/ModalMessages.vue'
  import ModalForgotPassword from 'components/Modais/ModalForgotPassword.vue'
</script>
<template>
  <MainLayout>
    <div class="slot-body">
      <div class="l-main mt-5">
        <div class="row img-mobile" v-if="!isLoggedIn">
          <div class="row align-items-center justify-content-center margin-login">
            <div class="col-xl-9 col-md-9 col-12 order-2 order-lg-1">
              <div class="row d-flex justify-content-center align-items-center">
                <div class="d-flex justify-content-center align-items-center mt-2">
                  <span class="header-text-2">{{ translate.footer1ModalPlan }}</span>
                  <span class="header-text-1 px-1">{{ translate.footer2ModalPlan }}</span>
                </div>
              </div>
              <form @submit.prevent="getLogin">
                <div class="form-group row d-flex align-items-center px-lg-5 px-2">
                  <div class="col-lg-5 col-md-5 col-12">
                    <input
                      type="text"
                      class="form-control"
                      id="inputEmail"
                      aria-describedby="emailHelp"
                      :placeholder="translate.placeHolderEmail"
                      name="email"
                      v-model="email"
                    />
                  </div>
                  <div class="col-lg-5 col-md-5 col-12 input-group">
                    <input
                      v-if="hidden"
                      type="password"
                      class="form-control"
                      name="password"
                      id="inputPassword"
                      :placeholder="translate.placeHolderPassword"
                      autocomplete="current-password"
                      v-model="password"
                    />
                    <input
                      v-if="!hidden"
                      type="text"
                      class="form-control"
                      name="password"
                      id="inputPassword2"
                      :placeholder="translate.placeHolderPassword"
                      autocomplete="current-password"
                      v-model="password"
                    />
                    <i @click="hiddenPassword" class="input-group-text icon-eye"></i>
                  </div>
                  <div class="col-lg-2 col-12 text-center" v-if="loading">
                    <div class="spinner-border" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </div>
                  <div class="col-lg-2 col-12 d-flex justify-content-center" v-else>
                    <div class="d-w-btn">
                      <button>{{ translate.buttonLabel }} <i class="icon-arrow-right"></i></button>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="col-12 d-flex justify-content-center pb-3">
                    <span class="small">{{ translate.forgotPwd1 }}</span
                    >&nbsp;
                    <span class="small small-link" @click="showModalForgotPassword(true)">{{
                      translate.forgotPwd2
                    }}</span>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div v-else class="col-10 text-center mt-5">
          <h1 class="hello">
            {{ locale == 'pt-br' ? 'Olá' : 'Hello' }}, {{ user.nickname ?? user.name }}!
            {{ locale == 'pt-br' ? 'COMPRE AQUI SEUS CRÉDITOS' : 'Buy your credits here' }}
          </h1>
        </div>
        <div class="block block--gray">
          <div class="container">
            <FormUser v-if="!isLoggedIn" />
            <FormPlansCreditsSelect v-if="plansCredits.length > 0" :plans="plansCredits" />
            <TermsUse v-if="!isLoggedIn" />
            <FormCheckout @showModalMessages="showModalMessages" @boleto="showPdfBoleto" />
            <PdfComponent v-if="urlPdf" :url="urlPdf" />
          </div>
        </div>
      </div>
    </div>
    <ModalMessages :options="optionsModal" @showModalMessages="showModalMessages" />
    <ModalForgotPassword
      :showModalPwd="showModalPwd"
      @showModalForgotPassword="showModalForgotPassword"
      @showModalMessages="showModalMessages"
    />
  </MainLayout>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import api from '../../api'
  import { mapState, mapActions } from 'pinia'
  import { localeStore } from '../../stores/locale'
  import translaters from '../../tradutors/myaccount'
  import { planCreditStore } from 'stores/planscredits'
  import { isMobile } from 'views/shared/utils/mobile'
  import { userStore } from '../../stores/user'
  import PdfComponent from 'components/PdfComponent.vue'
  import { event } from 'vue-gtag'
  import { jwtStore } from 'stores/jwt'

  export default defineComponent({
    name: 'AssineOptionsPage',
    head() {
      return {
        templateParams: {
          subTitle: null,
          subPage: this.locale == 'pt-br' ? 'Assine' : 'Subscribe Now',
          page_url: window.location.origin + this.$route.fullPath,
          page_description:
            this.locale == 'pt-br'
              ? `Quer ver tudo sem censura? Assine agora e tenha acesso ao conteúdo VIP`
              : `Want to see everything uncensored? Subscribe now and get access to VIP content`,
          page_image: '/favicon.ico',
          page_keywords:
            'bella, bella da semana, bela da semana, bella semana, bela semana, belladasemana, bella site, bella da semana site',
          page_locale: this.locale,
          page_url_pt: 'https://belladasemana.com.br/pt-br/buy/credits',
          page_url_en: 'https://belladasemana.com.br/en/buy/credits',
          page_canonical: 'https://belladasemana.com.br' + this.$route.fullPath
        }
      }
    },
    computed: {
      ...mapState(localeStore, ['locale']),
      ...mapState(planCreditStore, ['plansCredits', 'languagePlansCredits']),
      ...mapState(userStore, ['user', 'isLoggedIn']),
      translate: function () {
        if (this.locale == 'en') return translaters.ingles
        return translaters.portugues
      }
    },
    watch: {
      locale: function () {
        this.getPlans()
      }
    },
    created() {
      const lang = ['pt-br', 'en']
      if (lang.indexOf(this.$route.params.locale) === -1) {
        window.location.replace('/')
      }
      if (
        this.$route.query.coupon ||
        this.locale !== this.languagePlansCredits ||
        this.$route.query.voucher
      )
        this.getPlans()
    },
    data() {
      return {
        isMobile: isMobile(),
        urlPdf: '',
        hidden: true,
        password: '',
        email: '',
        loading: false,
        showModalPwd: false,
        optionsModal: {
          showModal: false,
          titleModal: 'Erro',
          textBodyModal: '',
          textButtonModal: ''
        }
      }
    },
    methods: {
      ...mapActions(planCreditStore, ['setPlanCredits']),
      ...mapActions(userStore, ['setUser', 'setIsActiveUser']),
      ...mapActions(jwtStore, ['setJwt']),
      hiddenPassword() {
        this.hidden = !this.hidden
      },
      checkForm(form: { email: string; password: string }) {
        if (!form.email) {
          this.error(this.locale == 'pt-br' ? 'Email é obrigatório!' : 'Email is required!')
          return false
        }
        if (!form.password) {
          this.error(this.locale == 'pt-br' ? 'Senha é obrigatória!' : 'Password is required!')
          return false
        }
        return true
      },
      error(value) {
        this.showModalMessages({
          message: { show: true, title: 'Erro', textButton: 'Fechar', textBoby: value }
        })
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'erro',
          erro: {
            tipo: value
          }
        })
      },
      async getLogin() {
        this.loading = true
        let body = {
          email: this.email,
          password: this.password
        }
        if (this.checkForm(body))
          await api
            .post('auth/login', body, {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
              }
            })
            .then(async ({ data }) => {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'login',
                login: { email: this.email }
              })
              event('login2', { login: { email: this.email } })
              await this.setUser(data.user)
              await this.setJwt(data.authorisation.token)
              await this.getActiveUser()
              window.location.reload()
            })
            .catch(({ response: { data } }) => {
              if (data.errors) {
                let array = Array.from(Object.entries(data.errors), ([key, value]) => value)
                this.error(array[0][0])
              } else
                this.error(
                  this.locale == 'pt-br' ? 'Email ou Senha inválidos' : 'Email or Password invalid'
                )
            })
            .finally(() => {
              this.loading = false
            })
        else this.loading = false
      },
      showModalForgotPassword(data) {
        this.showModalPwd = data
      },
      getPlans() {
        api
          .get(
            `v1/home/getPlansCredits?language=${this.locale ?? ''}&coupon=${
              this.$route.query.coupon ?? ''
            }`
          )
          .then(({ data }) => {
            this.setPlanCredits(data.plans)
          })
      },
      showModalMessages({ message }) {
        this.optionsModal.showModal = message.show
        this.optionsModal.titleModal = message.title
        this.optionsModal.textBodyModal = message.textBoby
        this.optionsModal.textButtonModal = message.textButton
      },
      showPdfBoleto(value: string) {
        this.urlPdf = value
      }
    }
  })
</script>

<style scoped lang="css">
  .img-middle {
    width: 100%;
    height: 600px;
    right: -1px;
  }

  .margin-login {
    margin-top: 75px;
    padding-top: 10px;
  }
  .hello {
    font-family: 'Bebas-Neue';
    font-size: 30px;
    font-weight: 400;
    line-height: 36px;
    text-align: center;
    margin: 0 auto;
    color: #5b5858;
    margin-top: 75px;
    padding-top: 30px;
    height: 90px;
  }

  .header-text-1 {
    font-family: 'Bebas-Neue';
    font-size: 30px;
    font-weight: 400;
    line-height: 36px;
    letter-spacing: 0;
    text-transform: uppercase;
  }

  .header-text-2 {
    font-family: 'Bebas-Neue';
    font-size: 30px;
    font-weight: 400;
    line-height: 36px;
    letter-spacing: 0;
    text-transform: uppercase;
    color: #b0030b;
  }

  .d-w-btn button {
    color: #fff;
    padding: 5px;
  }

  .d-w-btn {
    width: 130px;
    background: #000;
    border-radius: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 11px;
    color: #ffffff;
    font-family: 'Exo-2';
    font-size: 16px;
    letter-spacing: 0;
    top: -7px;
  }

  .form-group input {
    padding: 15px 20px;
    border-radius: 30px;
    margin-bottom: 15px;
    background-color: #f8f8f8;
    font-size: small;
  }

  .input-group {
    width: 41.66666667%;
  }
  .input-group-text {
    padding: 0;
    padding-left: 5px;
    font-size: 2rem;
    background-color: #f8f8f8;
    border: 1px solid #ced4da;
    border-radius: 30px;
    border-left-style: hidden;
    height: 52px;
  }

  #inputPassword2 {
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
  }

  .icon-eye:before {
    color: #ced4da;
    margin-right: 0.5em;
    cursor: pointer;
  }

  .small {
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 13px;
    letter-spacing: 0;
    line-height: 15px;
  }

  .small-link {
    color: #b20000;
    font-family: 'Roboto-Medium';
    font-size: 13px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 15px;
    text-decoration: underline;
    cursor: pointer;
  }

  /* regras mobile 769vp */
  @media screen and (max-width: 769px) {
    .img-middle {
      width: 100%;
      height: 392px;
      right: unset;
    }

    .input-group {
      width: 100%;
    }

    .hello {
      font-family: 'Bebas-Neue';
      font-size: 24px;
      font-weight: 400;
      line-height: 36px;
      margin-bottom: 5px;
    }

    .header-text-1 {
      font-family: 'Bebas-Neue';
      font-size: 18px;
      font-weight: 400;
      line-height: 14px;
      margin-bottom: 16px;
    }

    .header-text-2 {
      font-family: 'Bebas-Neue';
      font-size: 18px;
      font-weight: 400;
      line-height: 14px;
      margin-bottom: 16px;
      color: #b0030b;
    }

    .div-shadow::after {
      box-shadow: rgba(0, 0, 0, 0.6) 0px -60px 36px -28px inset;
      content: '';
      display: block;
      width: 97%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      margin-left: 7px;
    }

    .img-mobile {
      margin-left: unset;
      margin-right: unset;
    }
  }
</style>
